'use client'
import { memo, type PropsWithChildren } from 'react'

import { SubSectionTitle } from '@/components/common/SubSectionTitle'

export interface MarketActivitySectionLayoutProps extends PropsWithChildren {
  borrowersSlot: React.ReactNode
  suppliersSlot: React.ReactNode
  allTransactionsSlot: React.ReactNode
}

const MarketActivitySectionLayout = ({
  suppliersSlot,
  borrowersSlot,
  allTransactionsSlot
}: MarketActivitySectionLayoutProps) => {
  return (
    <div className="gap-lg sm:gap-xl flex grow flex-col">
      <div className="gap-sm flex flex-col" data-testid="market-borrowers">
        <SubSectionTitle>Borrowers</SubSectionTitle>
        {borrowersSlot}
      </div>
      <div className="gap-sm flex flex-col" data-testid="market-suppliers">
        <SubSectionTitle>Suppliers</SubSectionTitle>
        {suppliersSlot}
      </div>
      {allTransactionsSlot}
    </div>
  )
}

export default memo(MarketActivitySectionLayout)
